import { Button, InputAdornment, TextField } from "@material-ui/core";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import DetailSection from "../../../components/DetailSection";

function sanitize(raw) {
  const onlyAllowed = raw.replace(/[^0-9.]/g, "");
  const [whole, ...rest] = onlyAllowed.split(".");
  return rest.length > 0 ? `${whole}.${rest.join("")}` : whole;
}

function addThousandsSeparators(intStr) {
  let out = "";
  for (let i = 0; i < intStr.length; i++) {
    if (i > 0 && (intStr.length - i) % 3 === 0) out += ",";
    out += intStr[i];
  }
  return out;
}

function formatLive(value) {
  if (value === "" || value == null) return "";
  const [whole, decimal] = value.split(".");
  const withCommas = addThousandsSeparators(whole);
  return decimal != null ? `${withCommas}.${decimal}` : withCommas;
}

export const PhoneNumberBillingSlice = ({ partner, saveAttribute }) => {
  const [monthlyFee, setMonthlyFee] = useState("");

  const currentCents = partner.crmBillingOptions?.phoneNumberMonthlyFee;

  useEffect(() => {
    setMonthlyFee(currentCents != null ? (currentCents / 100).toFixed(2) : "");
  }, [currentCents]);

  const handleSave = () => {
    const cents =
      monthlyFee !== "" ? Math.round(Number.parseFloat(monthlyFee) * 100) : null;
    saveAttribute({
      crmBillingOptions: {
        ...partner.crmBillingOptions,
        phoneNumberMonthlyFee: cents
      }
    })
      .then(() => toast.success("Phone number pricing updated"))
      .catch(() => toast.error("Failed to update phone number pricing"));
  };

  return (
    <DetailSection title="Phone Number Pricing">
      <div className="flex gap-4 items-center">
        <TextField
          label="Monthly Fee Per Number"
          type="text"
          value={formatLive(monthlyFee)}
          onChange={(e) => setMonthlyFee(sanitize(e.target.value))}
          inputProps={{ inputMode: "decimal", style: { textAlign: "right" } }}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>
          }}
          variant="outlined"
          size="small"
          style={{ minWidth: 220 }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
        >
          Save
        </Button>
      </div>
    </DetailSection>
  );
};
